import { Image } from 'src/components/ui/Image'
import { InView } from 'react-intersection-observer'
import { ensureHttps } from 'src/utils/stripUrl'
import { openShoppingMuse } from 'src/sdk/muse/openShoppingMuse'

import { PictosHomeLink } from './PictosHomeLink'
import type { PictosHomeItemData } from './pictosHome.constants'
import { DATA_BANNER_TYPE, PICTO_ITEM_CLASS_NAME } from './pictosHome.constants'

type PictosHomeItemProps = {
  item: PictosHomeItemData
  index: number
  onSelect: (name: string, imageAlt: string, index: number) => void
  onView: (item: PictosHomeItemData, index: number) => void
}

export function PictosHomeItem({
  item,
  index,
  onSelect,
  onView,
}: PictosHomeItemProps) {
  const content = (
    <>
      <span className="w-[73px] h-[73px] restructure-small-desktop:w-[92px] restructure-small-desktop:h-[92px] flex items-center justify-center bg-lightGray rounded-full">
        <Image
          loading="eager"
          fetchpriority="high"
          src={item?.image}
          height={106}
          width={106}
          alt=""
          aria-hidden="true"
          title={item.text}
          data-id={item.text}
          data-banner-type={DATA_BANNER_TYPE}
          className="mix-blend-multiply w-[53px] h-[53px] restructure-small-desktop:w-[66px] restructure-small-desktop:h-[66px]"
        />
      </span>
      <h2
        data-testid="picto-text"
        className={`${
          item.isMuseEntryPoint ? 'dy-muse-widget-container-modal ' : ''
        }text-center font-inter mt-3 text-font-size-1 font-medium text-restructure-primary line-clamp-2 restructure-tablet:text-font-size-2 restructure-tablet:leading-[15px]`}
      >
        {item.text}
      </h2>
    </>
  )

  return (
    <InView
      as="li"
      threshold={0.7}
      onChange={(inView) => {
        if (inView) {
          onView(item, index)
        }
      }}
      triggerOnce
      draggable={false}
      data-testid="picto-card"
      className="picto-card"
    >
      {item.isMuseEntryPoint ? (
        <button
          type="button"
          className={`${PICTO_ITEM_CLASS_NAME} dy-chat-cta`}
          data-dy-id="muse-picto-home"
          onClick={() => {
            onSelect(item.text, item.altImage, index)
            openShoppingMuse()
          }}
        >
          {content}
        </button>
      ) : (
        <PictosHomeLink
          to={ensureHttps(item.linkUrl)}
          className={PICTO_ITEM_CLASS_NAME}
          onClick={() => onSelect(item.text, item.altImage, index)}
        >
          {content}
        </PictosHomeLink>
      )}
    </InView>
  )
}
